import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { gateway } from "../gateway";
import {
  updateSignupEmployeeState
} from "../redux/features/signupEmployeeStateSlice";
import { CheckExperienceCommercial, } from "./checkboxExperienceCommercial";
import { SignUpNextButton } from "./signupNextButton";

export const ConnectEmployeeEight = ({
  checkedState,
  nextViewComponentState,
  previousViewEntityState,
  updateComponentState = updateSignupEmployeeState,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currPage = "/signupEmployee";
  const commertialType = "commercial"; //The type that will be put on the
  const [commercialServices, setCommercialServices] = useState([]);

  const getWorkServiceByType = async (type) => {
    try {
      const response = await gateway.get(
        `/workservices?type=${commertialType}`
      );
      const data = response.data.data.items;

      setCommercialServices(data);
      console.log("the data: ", data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getWorkServiceByType(commertialType);
  }, []);

  return (
    <div
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "auto",
      }}
    >
      <Box
        style={{
          borderRadius: "10px",
          backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
          alignItems: "center",
          transition: "opacity 1s ease-in-out",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          height: "auto",
        }}
        sx={{
          marginTop: { xs: 2, md: 0 },
          width: { xs: "100%", md: 600 },
          marginLeft: { md: -15 },
        }}
      >
        <Grid container>
          <Grid item xs={12} md={12}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                marginBottom: "20px",
                textAlign: "center",
                backgroundColor: "var(--fx-surface-sidebar, #233044)",
                color: "white",
                padding: "8px",
                borderRadius: "10px",
              }}
            >
              Areas of experience
            </Typography>
            <CheckExperienceCommercial
              checkedState={checkedState}
              data={commercialServices}
              updateComponentState={updateComponentState}
            />
          </Grid>
        </Grid>

        <SignUpNextButton
          // type="submit"
          sx={{
            marginTop: "20px",
          }}
          nextViewEntityState={nextViewComponentState}
          previousViewEntityState={previousViewEntityState}
        ></SignUpNextButton>
      </Box>
    </div>
  );
};
